exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_wks-ext.js
// module id = 328
// module chunks = 17